const translations = {
    "en-US": {
        "payButton": "Save",
        "payButton.redirecting": "Redirecting...",
        "payButton.with": "Pay %{value} with %{maskedData}",
        "storeDetails": "Save for my next payment",
        "creditCard.holderName": "Name on card",
        "creditCard.holderName.placeholder": "J. Smith",
        "creditCard.holderName.invalid": "Invalid cardholder name",
        "creditCard.numberField.title": "Card number",
        "creditCard.numberField.placeholder": "1234 5678 9012 3456",
        "creditCard.expiryDateField.title": "Expiry date",
        "creditCard.expiryDateField.placeholder": "MM/YY",
        "creditCard.expiryDateField.month": "Month",
        "creditCard.expiryDateField.month.placeholder": "MM",
        "creditCard.expiryDateField.year.placeholder": "YY",
        "creditCard.expiryDateField.year": "Year",
        "creditCard.cvcField.title": "CVC / CVV",
        "creditCard.cvcField.placeholder": "123",
        "creditCard.storeDetailsButton": "Remember for next time",
        "creditCard.cvcField.placeholder.4digits": "4 digits",
        "creditCard.cvcField.placeholder.3digits": "3 digits",
        "creditCard.taxNumber.placeholder": "YYMMDD / 0123456789",
        "installments": "Number of installments",
        "installmentOption": "%{times}x %{partialValue}",
        "installmentOptionMonths": "%{times} months",
        "installments.oneTime": "One time payment",
        "installments.installments": "Installments payment",
        "installments.revolving": "Revolving payment",
        "sepaDirectDebit.ibanField.invalid": "Invalid account number",
        "sepaDirectDebit.nameField.placeholder": "J. Smith",
        "sepa.ownerName": "Holder Name",
        "sepa.ibanNumber": "Account Number (IBAN)",
        "error.title": "Error",
        "error.subtitle.redirect": "Redirect failed",
        "error.subtitle.payment": "Payment failed",
        "error.subtitle.refused": "Payment refused",
        "error.message.unknown": "An unknown error occurred",
        "errorPanel.title": "Existing errors",
        "idealIssuer.selectField.title": "Bank",
        "idealIssuer.selectField.placeholder": "Select your bank",
        "creditCard.success": "Payment Successful",
        "loading": "Loading…",
        "continue": "Continue",
        "continueTo": "Continue to",
        "wechatpay.timetopay": "You have %@ to pay",
        "wechatpay.scanqrcode": "Scan QR code",
        "personalDetails": "Personal details",
        "companyDetails": "Company details",
        "companyDetails.name": "Company name",
        "companyDetails.registrationNumber": "Registration number",
        "socialSecurityNumber": "Social security number",
        "firstName": "First name",
        "infix": "Prefix",
        "lastName": "Last name",
        "mobileNumber": "Mobile number",
        "mobileNumber.invalid": "Invalid mobile number",
        "city": "City",
        "postalCode": "Postal code",
        "countryCode": "Country Code",
        "telephoneNumber": "Telephone number",
        "dateOfBirth": "Date of birth",
        "shopperEmail": "Email address",
        "gender": "Gender",
        "male": "Male",
        "female": "Female",
        "billingAddress": "Billing address",
        "street": "Street",
        "stateOrProvince": "State or province",
        "country": "Country",
        "houseNumberOrName": "House number",
        "separateDeliveryAddress": "Specify a separate delivery address",
        "deliveryAddress": "Delivery Address",
        "zipCode": "Zip code",
        "apartmentSuite": "Apartment / Suite",
        "provinceOrTerritory": "Province or Territory",
        "cityTown": "City / Town",
        "address": "Address",
        "state": "State",
        "field.title.optional": "(optional)",
        "creditCard.cvcField.title.optional": "CVC / CVV (optional)",
        "issuerList.wallet.placeholder": "Select your wallet",
        "privacyPolicy": "Privacy policy",
        "afterPay.agreement": "I agree with the %@ of AfterPay",
        "paymentConditions": "payment conditions",
        "openApp": "Open the app",
        "voucher.readInstructions": "Read instructions",
        "voucher.introduction": "Thank you for your purchase, please use the following coupon to complete your payment.",
        "voucher.expirationDate": "Expiration Date",
        "voucher.alternativeReference": "Alternative Reference",
        "dragonpay.voucher.non.bank.selectField.placeholder": "Select your provider",
        "dragonpay.voucher.bank.selectField.placeholder": "Select your bank",
        "voucher.paymentReferenceLabel": "Payment Reference",
        "voucher.surcharge": "Incl. %@ surcharge",
        "voucher.introduction.doku": "Thank you for your purchase, please use the following information to complete your payment.",
        "voucher.shopperName": "Shopper Name",
        "voucher.merchantName": "Merchant",
        "voucher.introduction.econtext": "Thank you for your purchase, please use the following information to complete your payment.",
        "voucher.telephoneNumber": "Phone Number",
        "voucher.shopperReference": "Shopper Reference",
        "voucher.collectionInstitutionNumber": "Collection Institution Number",
        "voucher.econtext.telephoneNumber.invalid": "Telephone number must be 10 or 11 digits long",
        "boletobancario.btnLabel": "Generate Boleto",
        "boleto.sendCopyToEmail": "Send a copy to my email",
        "button.copy": "Copy",
        "button.download": "Download",
        "boleto.socialSecurityNumber": "CPF/CNPJ",
        "boleto.socialSecurityNumber.invalid": "Field is not valid",
        "creditCard.storedCard.description.ariaLabel": "Stored card ends in %@",
        "voucher.entity": "Entity",
        "donateButton": "Donate",
        "notNowButton": "Not now",
        "thanksForYourSupport": "Thanks for your support!",
        "preauthorizeWith": "Preauthorize with",
        "confirmPreauthorization": "Confirm preauthorization",
        "confirmPurchase": "Confirm purchase",
        "applyGiftcard": "Redeem",
        "giftcardBalance": "Gift card balance",
        "deductedBalance": "Deducted balance",
        "creditCard.pin.title": "Pin",
        "creditCard.encryptedPassword.label": "First 2 digits of card password",
        "creditCard.encryptedPassword.placeholder": "12",
        "creditCard.encryptedPassword.invalid": "Invalid password",
        "creditCard.taxNumber": "Cardholder birthdate or Corporate registration number",
        "creditCard.taxNumber.label": "Cardholder birthdate (YYMMDD) or Corporate registration number (10 digits)",
        "creditCard.taxNumber.labelAlt": "Corporate registration number (10 digits)",
        "creditCard.taxNumber.invalid": "Invalid Cardholder birthdate or Corporate registration number",
        "storedPaymentMethod.disable.button": "Remove",
        "storedPaymentMethod.disable.confirmation": "Remove stored payment method",
        "storedPaymentMethod.disable.confirmButton": "Yes, remove",
        "storedPaymentMethod.disable.cancelButton": "Cancel",
        "ach.bankAccount": "Bank account",
        "ach.accountHolderNameField.title": "Account holder name",
        "ach.accountHolderNameField.placeholder": "J. Smith",
        "ach.accountHolderNameField.invalid": "Invalid account holder name",
        "ach.accountNumberField.title": "Account number",
        "ach.accountNumberField.invalid": "Invalid account number",
        "ach.accountLocationField.title": "ABA routing number",
        "ach.accountLocationField.invalid": "Invalid ABA routing number",
        "select.state": "Select state",
        "select.stateOrProvince": "Select state or province",
        "select.provinceOrTerritory": "Select province or territory",
        "select.country": "Select country",
        "select.noOptionsFound": "No options found",
        "select.filter.placeholder": "Search...",
        "telephoneNumber.invalid": "Invalid telephone number",
        "qrCodeOrApp": "or",
        "paypal.processingPayment": "Processing payment...",
        "generateQRCode": "Generate QR code",
        "await.waitForConfirmation": "Waiting for confirmation",
        "mbway.confirmPayment": "Confirm your payment on the MB WAY app",
        "shopperEmail.invalid": "Invalid email address",
        "dateOfBirth.format": "DD/MM/YYYY",
        "dateOfBirth.invalid": "You must be at least 18 years old",
        "blik.confirmPayment": "Open your banking app to confirm the payment.",
        "blik.invalid": "Enter 6 numbers",
        "blik.code": "6-digit code",
        "blik.help": "Get the code from your banking app.",
        "swish.pendingMessage": "After you scan, the status can be pending for up to 10 minutes. Attempting to pay again within this time may result in multiple charges.",
        "field.valid": "Field valid",
        "field.invalid": "Field not valid",
        "error.va.gen.01": "Incomplete field",
        "error.va.gen.02": "Field not valid",
        "error.va.sf-cc-num.01": "Card number is not valid",
        "error.va.sf-cc-num.02": "Card number field is empty",
        "error.va.sf-cc-num.03": "Unsupported card number entered",
        "error.va.sf-cc-num.04": "Card number is the wrong length",
        "error.va.sf-cc-dat.01": "Expiry date: card too old",
        "error.va.sf-cc-dat.02": "Expiry date: date too far in the future",
        "error.va.sf-cc-dat.03": "Expiry date: your card expires before check out date",
        "error.va.sf-cc-dat.04": "Expiry date field is empty",
        "error.va.sf-cc-dat.05": "Expiry date is the wrong length",
        "error.va.sf-cc-mth.01": "Expiry month field is empty",
        "error.va.sf-cc-yr.01": "Expiry year field is empty",
        "error.va.sf-cc-yr.02": "Expiry year is the wrong length",
        "error.va.sf-cc-cvc.01": "Security code field is empty",
        "error.va.sf-cc-cvc.02": "Security code is the wrong length",
        "error.va.sf-ach-num.01": "Bank account number field is empty",
        "error.va.sf-ach-num.02": "Bank account number is the wrong length",
        "error.va.sf-ach-loc.01": "Bank routing number field is empty",
        "error.va.sf-ach-loc.02": "Bank routing number is the wrong length",
        "error.va.sf-kcp-pwd.01": "Password field is empty",
        "error.va.sf-kcp-pwd.02": "Password is the wrong length",
        "error.giftcard.no-balance": "This gift card has zero balance",
        "error.giftcard.card-error": "In our records we have no gift card with this number",
        "error.giftcard.currency-error": "Gift cards are only valid in the currency they were issued in",
        "amazonpay.signout": "Sign out from Amazon",
        "amazonpay.changePaymentDetails": "Change payment details",
        "partialPayment.warning": "Select another payment method to pay the remaining",
        "partialPayment.remainingBalance": "Remaining balance will be %{amount}",
        "bankTransfer.beneficiary": "Beneficiary",
        "bankTransfer.iban": "IBAN",
        "bankTransfer.bic": "BIC",
        "bankTransfer.reference": "Reference",
        "bankTransfer.introduction": "Continue to create a new bank transfer payment. You can use the details in the following screen to finalize this payment.",
        "bankTransfer.instructions": "Thank you for your purchase, please use the following information to complete your payment.",
        "bacs.accountHolderName": "Bank account holder name",
        "bacs.accountHolderName.invalid": "Invalid bank account holder name",
        "bacs.accountNumber": "Bank account number",
        "bacs.accountNumber.invalid": "Invalid bank account number",
        "bacs.bankLocationId": "Sort code",
        "bacs.bankLocationId.invalid": "Invalid sort code",
        "bacs.consent.amount": "I agree that the above amount will be deducted from my bank account.",
        "bacs.consent.account": "I confirm the account is in my name and I am the only signatory required to authorise the Direct Debit on this account.",
        "edit": "Edit",
        "bacs.confirm": "Confirm and pay",
        "bacs.result.introduction": "Download your Direct Debit Instruction (DDI / Mandate)",
        "download.pdf": "Download PDF",
        "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe for secured card number",
        "creditCard.encryptedCardNumber.aria.label": "Card number",
        "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe for secured card expiry date",
        "creditCard.encryptedExpiryDate.aria.label": "Expiry date",
        "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe for secured card expiry month",
        "creditCard.encryptedExpiryMonth.aria.label": "Expiry month",
        "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe for secured card expiry year",
        "creditCard.encryptedExpiryYear.aria.label": "Expiry year",
        "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe for secured card security code",
        "creditCard.encryptedSecurityCode.aria.label": "Security code",
        "creditCard.encryptedPassword.aria.iframeTitle": "Iframe for secured card password",
        "creditCard.encryptedPassword.aria.label": "First 2 digits of card password",
        "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe for secured gift card number",
        "giftcard.encryptedCardNumber.aria.label": "Gift card number",
        "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe for secured gift card security code",
        "giftcard.encryptedSecurityCode.aria.label": "Gift card security code",
        "giftcardTransactionLimit": "Max. %{amount} allowed per transaction on this gift card",
        "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe for secured bank account number",
        "ach.encryptedBankAccountNumber.aria.label": "Bank account",
        "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe for secured bank routing number",
        "ach.encryptedBankLocationId.aria.label": "Bank routing number",
        "pix.instructions": "Open the app with the PIX registered key, choose Pay with PIX and scan the QR Code or copy and paste the code",
        "twint.saved": "saved",
        "orPayWith": "or pay with",
        "invalidFormatExpects": "Invalid format. Expected format: %{format}",
        "upi.qrCodeWaitingMessage": "Scan the QR code using your preferred UPI app to complete the payment",
        "upi.vpaWaitingMessage": "Open your UPI app to confirm the payment",
        "upi.modeSelection": "Make a selection on how you would like to use UPI.",
        "onlineBanking.termsAndConditions": "By continuing you agree with the %#terms and conditions%#",
        "ctp.loading.poweredByCtp": "Powered by Click to Pay",
        "ctp.loading.intro": "We are checking to see if you have any saved cards with Click to Pay...",
        "ctp.login.title": "Continue to Click to Pay",
        "ctp.login.subtitle": "Enter the email address that is connected to Click to Pay to continue.",
        "ctp.login.inputLabel": "Email",
        "ctp.logout.notYou": "Not you?",
        "ctp.logout.notYourCards": "Not your cards?",
        "ctp.logout.notYourCard": "Not your card?",
        "ctp.logout.notYourProfile": "Not your profile?",
        "ctp.otp.fieldLabel": "One time code",
        "ctp.otp.resendCode": "Resend code",
        "ctp.otp.codeResent": "Code resent",
        "ctp.otp.title": "Access your Click to Pay cards",
        "ctp.otp.subtitle": "Enter the code %@ sent to %@ to verify it‘s you.",
        "ctp.emptyProfile.message": "No cards registered in this Click to Pay profile",
        "ctp.separatorText": "or use",
        "ctp.cards.title": "Complete payment with Click to Pay",
        "ctp.cards.subtitle": "Select a card to use.",
        "ctp.cards.expiredCard": "Expired",
        "ctp.manualCardEntry": "Manual card entry",
        "ctp.infoPopup.title": "Click to Pay brings the ease of contactless, online",
        "ctp.infoPopup.subtitle": "A fast, secure payment method supported by Mastercard, Visa and other payment cards.",
        "ctp.infoPopup.benefit1": "Click to Pay uses encryption to keep your information safe and secure",
        "ctp.infoPopup.benefit2": "Use it with merchants worldwide",
        "ctp.infoPopup.benefit3": "Set up once for hassle-free payments in the future",
        "ctp.errors.AUTH_INVALID": "Authentication Invalid",
        "ctp.errors.NOT_FOUND": "No account found, enter a valid email or continue using manual card entry",
        "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format not supported",
        "ctp.errors.FRAUD": "The user account was locked or disabled",
        "ctp.errors.CONSUMER_ID_MISSING": "Consumer identity is missing in the request",
        "ctp.errors.ACCT_INACCESSIBLE": "This account is currently not available, e.g it is locked",
        "ctp.errors.CODE_INVALID": "Incorrect verification code",
        "ctp.errors.CODE_EXPIRED": "This code has expired",
        "ctp.errors.RETRIES_EXCEEDED": "The limit for the number of retries for OTP generation was exceeded",
        "ctp.errors.OTP_SEND_FAILED": "The OTP could not be sent to the recipient",
        "ctp.errors.REQUEST_TIMEOUT": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.UNKNOWN_ERROR": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.SERVICE_ERROR": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.SERVER_ERROR": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.INVALID_PARAMETER": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.AUTH_ERROR": "Something went wrong, try again or use the manual card entry",
        "a11y.paymentMethodsList": "Choose a payment method"
    }
};

export default translations;